<template>
    <div class="root">
        <el-form
          ref="form"
          :model="searchForm"
          :rules="rules"
          label-width="150px"
          label-position="left"
        >
          <el-form-item label="空间名称" prop="name">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入空间名称"
              size="small"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="单位" prop="unit">
            <el-input
              v-model="searchForm.unit"
              placeholder="请输入单位"
              size="small"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="别名" prop="theAlias">
            <el-input
              v-model="searchForm.theAlias"
              placeholder="请输入别名"
              size="small"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number
              :min="0"
              style="width: 100%;"
              controls-position="right"
              v-model="searchForm.sort"
              placeholder="请输入排序"
              size="small"
              clearable
            ></el-input-number>
          </el-form-item>
        </el-form>
    </div>
  </template>
  
  <script>
  import { postFun,getFun,putFun } from "@/utils/httpFun";
  import {url} from "@/utils/config";
  export default {

    props: {
      operate: {
        type: String,
        default: () => "add",
      },
      edits: {
        type: Object,
        default: () => ({}),
      },
      count:{
        type:Number,
        default:()=>0
      }
    },
    data() {
      return {
        disabled: false,
        searchForm: {
            name:'',            // 空间名称
            parentId:'',         // 父节点id 默认为0
            projectId:'',       // 项目id
            level:'',           // 等级 如果是最顶层
            theAlias:'',        // 别名
            sort:'',            // 排序
            unit:'',            // 单位
        },
        rules: {
            name: [
                {
                    required: true,
                    message: "请输入空间名称",
                    trigger: "blur",
                },
            ],
            // theAlias: [
            //     {
            //         required: true,
            //         message: "请输入别名",
            //         trigger: "blur",
            //     },
            // ],
            // unit: [
            //     {
            //         required: true,
            //         message: "请输入单位",
            //         trigger: "blur",
            //     },
            // ],
            sort: [
                {
                    required: true,
                    message: "请输入排序",
                    trigger: "blur",
                },
            ],
        },
        roles: [],
      };
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        if(this.operate == 'edit'){
          this.searchForm.name = this.edits.emun.name;
          this.searchForm.parentId = this.edits.emun.parentId;
          this.searchForm.projectId = this.edits.projectId;
          this.searchForm.level = this.edits.emun.level;
          this.searchForm.theAlias = this.edits.emun.theAlias;
          this.searchForm.sort = this.edits.emun.sort;
          this.searchForm.unit = this.edits.emun.unit;
        }else
          this.searchForm.sort = this.count;
      },
      addAgent() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            let params = {};
            
            switch(this.operate){
                case "add":
                    this.searchForm.parentId = 0;
                    this.searchForm.projectId = this.edits.id;
                    this.searchForm.level = 0;
                    this.searchForm.theAlias = this.searchForm.theAlias == ''?this.searchForm.name:this.searchForm.theAlias;

                    params = {
                       ...this.searchForm,
                       operator:this.$store.state.agentUser.agentUserVo.name
                    }

                    postFun(url.PROJECT.ADDTHREEEMUN, params, (res) => {
                        if (res.code == 1) {
                            this.$message({
                                message: "新增成功",
                                type: "success",
                            });
                        } else {
                            this.$message.warning("新增失败");
                        }
                        this.close();
                    });
                    
                break;
                case 'addChildren':
                    this.searchForm.parentId = this.edits.emun.id;
                    this.searchForm.projectId = this.edits.project.id;
                    this.searchForm.level = this.edits.emun.level+1;

                    params = {
                       ...this.searchForm,
                       operator:this.$store.state.agentUser.agentUserVo.name
                    }
                    postFun(url.PROJECT.ADDTHREEEMUN, params, (res) => {
                        if (res.code == 1) {
                            this.$message({
                                message: "新增成功",
                                type: "success",
                            });
                        } else {
                            this.$message.warning("新增失败");
                        }
                        this.close();
                    });
                    
                break;
                case "edit":
              
                  
                  params = {
                    id:this.edits.emun.id,
                    name:this.searchForm.name,
                    theAlias:this.searchForm.theAlias,
                    sort:this.searchForm.sort,
                    unit:this.searchForm.unit,
                    // operator:this.$store.state.agentUser.agentUserVo.name
                  }

                  postFun(url.PROJECT.EDITHTEEMEUN,params,res=>{
                    if (res.code == 1) {
                            this.$message({
                                message: "编辑成功",
                                type: "success",
                            });
                            // this.$parent.threeList()
                        } else {
                            this.$message.warning("编辑失败");
                        }
                        this.close();
                  })
                break;
                case "del":
                break;
                default:
                  this.$message.warning("程序错误")
                return;
            }
          }
        });
      },
      close() {
        this.searchForm = {
            name:'',            // 空间名称
            parentId:'',         // 父节点id 默认为0
            projectId:'',       // 项目id
            level:'',           // 等级 如果是最顶层
            theAlias:'',        // 别名
            sort:'',            // 排序
            unit:'',            // 单位
        }
        this.$emit("close");
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  </style>
  